/**
 * 공용 로그아웃 훅 — 모든 페이지의 로그아웃 경로 단일화
 *
 * 로그아웃은 반드시 authStore.signOut()(토큰 revoke + OIDC 세션·refresh 정리)을
 * 거쳐야 한다. signOut 없이 navigate('/login')만 하면 authStore.user가 살아 있어
 * 공개 라우트 래퍼(PublicOnlyRoute)가 즉시 원래 자리로 되돌리고, 세션도 그대로
 * 남는다 (#269). 페이지별 로그아웃 핸들러는 전부 이 훅을 사용한다.
 */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/app/stores/authStore';

export function useLogout(): () => Promise<void> {
  const navigate = useNavigate();
  const signOut = useAuthStore((s) => s.signOut);

  return useCallback(async () => {
    await signOut();
    // 프로젝트 소유자 컨텍스트(userId) 정리는 편집기 스토어가 signOutHooks 등록부에 등록해 스스로 한다(useStore.ts, authStore 의 SIGNED_OUT 처리가 부른다) —
    // 이 훅이 편집기 스토어를 가져오면 진입 청크에 도메인이 실린다(트랙 A-4)
    // 첨부 blob URL 캐시 정리는 authStore 의 SIGNED_OUT 처리에 있다 —
    // 명시 로그아웃과 refresh 실패가 같은 지점을 지나게(정리 지점 단일화)
    navigate('/login');
  }, [signOut, navigate]);
}
